<div class="table-container">
  <ng-container
    *ngIf="
      listOptions.total > 0 ||
        (listOptions.search && listOptions?.search?.length > 0) ||
        (listOptions.filters && listOptions.filters.size && listOptions.filters.size > 1);
      else elseTemplate
    "
  >
    <div class="table">
      <ng-content></ng-content>
    </div>
    <lms-list-paginator
      *ngIf="!listOptions.hidePaginator && listOptions.total > 0"
      [listId]="listId"
    ></lms-list-paginator>
  </ng-container>
  <ng-template #elseTemplate>
    <ng-content select="[empty-content]" empty-content></ng-content>
    <div *ngIf="!listOptions.hideEmptyLabel" class="center-align">{{ 'nouns.empty' | translate }}</div>
  </ng-template>
</div>
